




















































































































































import {
  computed,
  defineComponent,
  PropType,
  toRefs,
  ref
} from '@nuxtjs/composition-api'
import CProgressBar from '~/components/shared/configurable/progress-bar/CProgressBar.vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { ciPlay } from '~/icons/source/regular/play'
import { ShortVideo, ShortVideoStatus } from '~/models/short-video'
import { defineComponentTranslations } from '~/utils/i18n'
import {
  faBan,
  faClock,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
import { useI18n } from '~/compositions/i18n'
import { ciTrash } from '~/icons/source/solid/trash'
import { ciExclamationCircle } from '~/icons/source/solid/exclamation-circle'

export default defineComponent({
  components: { CProgressBar, CImg, CShimmer },
  props: {
    video: {
      type: Object as PropType<ShortVideo>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const { video } = toRefs(props)
    const isShimmerVisible = ref(true)
    const hasLoadError = ref(false)
    const isTouchMoved = ref(false)
    const { t } = useI18n()

    function handleDelete() {
      if (isTouchMoved.value) {
        isTouchMoved.value = false
        return
      }
      emit('delete')
    }

    function handleTitleInput(title: string) {
      emit('title-change', title)
    }

    const notAllowedCursor = computed(
      () =>
        ![ShortVideoStatus.PUBLIC, ShortVideoStatus.PENDING].includes(
          video.value.status
        ) && hasLoadError.value
    )

    const errorToShow = computed(() => {
      if (hasLoadError.value) {
        return t('upload_error')
      } else if (video.value.status === ShortVideoStatus.HIDDEN) {
        return video.value.isNonPublicReason
      }
      return null
    })

    const formatedDuration = computed(() => {
      const duration = video.value?.extras?.duration
      if (!duration) {
        return ''
      }

      return `${Math.floor(parseInt(duration, 10) / 60)}:${(
        parseInt(duration, 10) % 60
      )
        .toString()
        .padStart(2, '0')}`
    })

    const borderColor = computed(() => {
      if (
        video.value.status === ShortVideoStatus.ERROR ||
        video.value.status === ShortVideoStatus.HIDDEN ||
        hasLoadError.value
      ) {
        return 'tw-border-red-300'
      } else if (video.value.status === ShortVideoStatus.PENDING) {
        return 'tw-border-cyan-300'
      }

      return 'tw-border-grey-300'
    })
    const bgColor = computed(() => {
      if (
        video.value.status === ShortVideoStatus.ERROR ||
        video.value.status === ShortVideoStatus.HIDDEN ||
        hasLoadError.value
      ) {
        return 'tw-bg-red-100'
      }

      return 'tw-bg-grey-50'
    })

    const nonPublicIconsAndColor = computed(() => {
      if (video.value.status === ShortVideoStatus.ERROR || hasLoadError.value) {
        return { icon: faTimesCircle, color: 'tw-text-grey-700' }
      } else if (video.value.status === ShortVideoStatus.HIDDEN) {
        return { icon: faBan, color: 'tw-text-red-400' }
      } else if (video.value.status === ShortVideoStatus.PENDING) {
        return { icon: faClock, color: 'tw-text-cyan-300' }
      }
    })

    function handleClick() {
      if (isTouchMoved.value) {
        isTouchMoved.value = false
        return
      }
      if (
        video.value.status === ShortVideoStatus.PENDING &&
        !hasLoadError.value
      ) {
        emit('edit-video', video.value)
      } else if (video.value.status === ShortVideoStatus.PUBLIC) {
        emit('play', video.value)
      }
    }

    function handleImageError() {
      hasLoadError.value = true
      isShimmerVisible.value = false
    }

    function handleTouchMove() {
      isTouchMoved.value = true
    }
    return {
      handleClick,
      hasLoadError,
      handleDelete,
      handleTouchMove,
      handleTitleInput,
      formatedDuration,
      isShimmerVisible,
      ShortVideoStatus,
      borderColor,
      bgColor,
      nonPublicIconsAndColor,
      handleImageError,
      notAllowedCursor,
      ciTrash,
      ciPlay,
      faClock,
      faTimesCircle,
      faBan,
      errorToShow,
      ciExclamationCircle
    }
  },
  i18n: defineComponentTranslations({
    in_processing: {
      en: 'Processing...',
      el: 'Σε επεξεργασία'
    },
    upload_error: {
      en: 'Upload error',
      el: 'Πρόβλημα μεταφόρτωσης'
    }
  })
})
